import React, { useState } from "react";
import { Card, CardHeader, Collapse } from "reactstrap";
import { CoberturaGrupo } from "./CoberturaGrupo";

export const Coberturas = ({ coberturas }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab" className={`${open && "active"}`}>
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Plan Cobertura"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <div className="container">
                        {(coberturas || []).map((i, idx) => (
                            <CoberturaGrupo key={idx} grupo={i[0]} coberturas={i[1]} />
                        ))}
                    </div>
                </Collapse>
            </Card>
        </div>
    );
};
